import * as React from "react";
import * as S from "@styled";
import styled from "styled-components";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";
import { Utilities } from "shared/utilities";
import { ParameterEditorValue } from "../../processEditor/model/ParameterEditorValue";
import CustomPopover from "./Popover";

const LabelWithTooltipColor = theme("mode", {
    [ThemeType.light]: S.Colors.black,
    [ThemeType.dark]: S.Colors.white
});

const LabelWithTooltipIconColor = theme("mode", {
  [ThemeType.light]: S.Colors.purpleDark ,
  [ThemeType.dark]: S.Colors.grey_4,
});

const LabelWithTooltipIconHoverColor = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.grey_3
});

interface StyledLabelWithTooltipProps {
    shouldNotDisplayIcon?: boolean;
}

const StyledLabelWithTooltip = styled(S.Label)<StyledLabelWithTooltipProps>`
    color: ${LabelWithTooltipColor};
    display: flex;
    gap: 14px;

    div {
        display: flex;
        align-items: center;
    }

    i {
        vertical-align: bottom;
        color: ${props => props.shouldNotDisplayIcon ? 'transparent' : LabelWithTooltipIconColor};
    }

    :hover {
        i {
            color: ${props => props.shouldNotDisplayIcon ? 'transparent' : LabelWithTooltipIconHoverColor};
        }
    }
`;

const LabelWithTooltip: React.FC<ILabelWithTooltipProps> = ({
    label,
    description,
    shouldNotDisplayIcon,
    type,
    defaultValue,
    doNotHumanizeLabel,
    containerClass,
    useHover,
}) => {
    const _label = doNotHumanizeLabel ? label : Utilities.humanizeLabel(label);
    const popoverBoundaryElementRef = React.useRef<HTMLDivElement | null>(null);
    const tooltip = String(`${description != undefined ? description : ""} ${type != undefined ? `\n${FRENDS.Localizations.Type}: ${type}` : ""} ${defaultValue != undefined ? `\n${FRENDS.Localizations.DefaultValue}: ${defaultValue}` : ""}`).trim();

    return (
        <StyledLabelWithTooltip
            className={containerClass}
            shouldNotDisplayIcon={shouldNotDisplayIcon}
        >
            {_label}
            {tooltip !== '' && (
                <div ref={popoverBoundaryElementRef}>
                    <CustomPopover
                        tooltip={tooltip}
                        boundaryElementRef={popoverBoundaryElementRef}
                        useHover={useHover}
                    >
                        <i className="ci-help_circle_outline pointer" />
                    </CustomPopover>
                </div>
            )}
        </StyledLabelWithTooltip>
    );
}

interface ILabelWithTooltipProps {
    label: string | undefined;
    description: string | undefined;
    shouldNotDisplayIcon?: boolean;
    type?: string;
    defaultValue?: string | number | boolean | null | ParameterEditorValue;
    doNotHumanizeLabel?: boolean;
    containerClass?: string;
    useHover?: boolean;
}

export default LabelWithTooltip;
